import BodyContentRenderer from '@components/body-content';
import type { ReactElement } from 'react';
import React from 'react';
import type { BasePage } from 'types/page';
import type { DataProps } from 'types/props/data-props';
import type SiteContext from 'types/site-context';

interface Props extends DataProps<BasePage> {
  context: SiteContext;
}

function GenericPage({ context, body }: Readonly<Props>): ReactElement | null {
  if (typeof body === 'undefined') {
    return null;
  }

  return <BodyContentRenderer body={body} context={context} />;
}

export default GenericPage;
